// src/pages/Clients/components/ClientFormModal.jsx
import React, { useEffect } from "react";
import { Modal, Form, Input, App } from "antd";
import { useDispatch } from "react-redux";
import { fetchClients, upsertClient } from "../clientsSlice";
import ClientLocationMap from "./ClientLocationMap";

const ClientFormModal = ({ open, onClose, edit, onSuccess, authInfo }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { message } = App.useApp();

  useEffect(() => {
    if (edit) {
      form.setFieldsValue({
        client_name: edit.name,
        latitude: edit.latitude,
        longitude: edit.longitude,
      });
    } else {
      form.resetFields();
    }
  }, [edit, open]);

  const onFinish = async (values) => {
    const payload = {
      id: edit?.id || 0,
      client_name: values.client_name.trim(),
      latitude: values.latitude,
      longitude: values.longitude,
      action: edit ? "update" : "create",
    };
    await dispatch(upsertClient(payload))
      .unwrap()
      .then((res) => {
        message.success(
          res?.msg || (edit ? "Client updated" : "Client created")
        );
        dispatch(fetchClients());

        // ✅ PASS CREATED NAME
        onSuccess?.(values.client_name.trim());

        onClose();
      })
      .catch((err) => message.error(err?.message || "Failed"));
  };

  return (
    <Modal
      open={open}
      title={edit ? "Edit Client" : "New Client"}
      onCancel={onClose}
      onOk={() => form.submit()}
      okText={edit ? "Save" : "Create"}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        requiredMark={(label, { required }) =>
          required ? (
            <>
              {label} <span style={{ color: "#ff4d4f" }}>*</span>
            </>
          ) : (
            label
          )
        }
      >
        <Form.Item
          label="Client Name"
          name="client_name"
          rules={[{ required: true, message: "Client Name is required" }]}
        >
          <Input placeholder="Client Name" />
        </Form.Item>

        {/* Coordinates are driven by the map */}
        <Form.Item label="Client Office Location">
          <ClientLocationMap
            value={{
              latitude: form.getFieldValue("latitude"),
              longitude: form.getFieldValue("longitude"),
            }}
            onChange={(loc) => {
              form.setFieldsValue({
                latitude: loc?.latitude ?? null,
                longitude: loc?.longitude ?? null,
              });
            }}
          />
        </Form.Item>

        <Form.Item
          name="latitude"
          hidden
          rules={[{ required: true, message: "Latitude is required" }]}
        />
        <Form.Item
          name="longitude"
          hidden
          rules={[{ required: true, message: "Longitude is required" }]}
        />
      </Form>
    </Modal>
  );
};

export default ClientFormModal;
